import type { ComponentTypes } from 'types/story';
import { COMPONENT_TYPE as CT } from 'common/constants';

const fieldRegexPattern = new RegExp(`${CT.CHECKBOX}|${CT.TEXT_FIELD}|${CT.TEXT_AREA_FIELD}|${CT.SELECT}`, 'gi');
export const isFieldBlock = ({ type }: { type: ComponentTypes }) => type.match(fieldRegexPattern) !== null;
